const aux = (props) => props.children;

export default aux;


// WEBPACK FOOTER //
// ./src/components/hoc/Aux.js